"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.gameRef = void 0;
const injets_1 = require("injets");
const game_module_1 = require("./game.module");
exports.gameRef = injets_1.createModule(game_module_1.GameModule);
